import cn from 'classnames'
import { CertificateProgram } from '@mc/api'
import { LogoSection } from 'pages/certificates/components/common/LogoSection'

interface CertHeadlineHeroProps {
  heroSection?: CertificateProgram['heroSection']
  programTitle: string
  programSubtitle?: string
  companyLogo?: { url: string; altText?: string }
  // The backend only serializes releaseLabel for a coming-soon program
  // (CertificateProgramSerializer#build_release_label), so its presence is the
  // only gate the pill needs. Opt-in: control passes nothing and is unchanged.
  releaseLabel?: string
}

export const CertHeadlineHero = ({
  heroSection,
  programTitle,
  programSubtitle,
  companyLogo,
  releaseLabel,
}: CertHeadlineHeroProps) => {
  const headline = heroSection?.headline || programTitle
  const subtitle = heroSection?.subheadline ?? programSubtitle
  const { eyebrow } = heroSection ?? {}

  return (
    <div className='flex w-full flex-col items-center lg:items-start'>
      <LogoSection
        companyLogo={companyLogo}
        alignLogoStart
        className={cn({
          'flex-col lg:items-start': eyebrow || releaseLabel,
        })}
      >
        {releaseLabel && (
          <span className='c-caption-mono mt-6 w-fit rounded-full bg-c-base-100 px-3 py-1 text-c-text-dark'>
            {releaseLabel}
          </span>
        )}
        {eyebrow && (
          <p
            className={cn(
              'c-heading-5 text-center text-c-text-tint-2 lg:text-left',
              releaseLabel ? 'mt-2' : 'mt-6',
            )}
          >
            {eyebrow}
          </p>
        )}
      </LogoSection>
      <div className='mt-4 text-center lg:text-left'>
        <h1 className='c-heading-1 c-text-ivar-display-condensed'>
          {headline}
        </h1>
        {subtitle && <p className='mt-4 text-c-text-tint-3'>{subtitle}</p>}
      </div>
    </div>
  )
}
